import {Controller} from "stimulus"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "modal",
        "video"
    ]

    initialize() {}

    open(){
        this.modalTarget.classList.add("is-open")
        this.videoTarget.play()
    }

    close(){
        this.modalTarget.classList.remove("is-open")
        this.videoTarget.pause()
    }
}
